import React, { useEffect, useCallback, useState, useRef } from "react";
import PropTypes from "prop-types";

import DateFormatingService from "services/DateFormatingService";
import LocalNewsService from "services/LocalNewsService";

import LocalNewsDropdown from "./LocalNewsDropdown";

const LocalNewsBlock = ({ settings, service }) => {
  const localNewsBlockRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [intersected, setIntersected] = useState(false);
  const [location, setLocation] = useState(null);
  const [teasers, setTeasers] = useState([]);

  const updateLocalNews = useCallback(async () => {
    setLoading(true);
    setTeasers([]);

    try {
      const { items } = await service.getLatestNews(location.id);

      setLoading(false);
      setTeasers(items.slice(0, 4));
    } catch (error) {
      console.log(error); // eslint-disable-line no-console
    }
  }, [location.id, service]);

  useEffect(() => {
    let io = null;

    const callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const savedLocation = LocalNewsService.getSavedLocation();

          setLocation(savedLocation || {});

          setIntersected(true);

          io.unobserve(localNewsBlockRef.current);
        }
      });
    };

    if (localNewsBlockRef) {
      io = new IntersectionObserver(callback);
      io.observe(localNewsBlockRef.current);
    }

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      io.unobserve(localNewsBlockRef.current);
    };
  }, [localNewsBlockRef]);

  useEffect(() => {
    if (intersected === true) {
      updateLocalNews();
    }
  }, [intersected, location, updateLocalNews]);

  useEffect(() => {
    window.updateElementQueries();
  });

  return (
    <div className="section local-news-block" ref={localNewsBlockRef}>
      {location && (
        <div className="section__header">
          <a
            className="section-heading"
            href={location && location.url ? location.url : "/gemeente"}
          >
            <span className="section-heading__title">
              <span className="section-heading__title__text">
                {settings.title} {location.text}
              </span>
              <span className="section-heading__link-wrapper">
                <span className="section-heading__link">Meer</span>
                <svg className="section-heading__icon" width="12" height="12">
                  <use xlinkHref="#chevron-right" width="12" height="12" />
                </svg>
              </span>
            </span>
          </a>
        </div>
      )}
      <div className="section__content container container--horizontal">
        {(loading || !location) && <div className="throbber" />}
        {loading === false && location && (
          <div className="local-news-block__content">
            <div className="local-news-block__header">
              <p className="local-news-block__title">
                {settings.dropdownPrefix}
              </p>
              <LocalNewsDropdown
                location={location}
                setLocation={(newLocation) => setLocation(newLocation)}
                updateInitialLocation
                settings={settings}
              />
            </div>
            <div className="is-list grid-flex of-4">
              {teasers.map((teaser) => (
                <a
                  className="card is-list"
                  href={teaser.url}
                  key={teaser.title}
                >
                  <div className="card__image">
                    <img src={teaser.image} alt="" />
                  </div>
                  <div className="card__content">
                    <h3 className="card__title">{teaser.title}</h3>
                    <div className="card__meta">
                      <span className="card__main main-tag">
                        {teaser.topic}
                      </span>
                      <span className="card__date">
                        {DateFormatingService.formatToTimeAndDate(
                          teaser.timestamp * 1000
                        )}
                      </span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

LocalNewsBlock.defaultProps = {
  settings: {},
  service: () => {},
};

LocalNewsBlock.propTypes = {
  settings: PropTypes.object,
  service: PropTypes.func,
};

export default LocalNewsBlock;
